import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Container} from "react-bootstrap";

const stepKeys = ["register", "fillIn", "getChecklist", "relax"];

export const HowItWorks: FC = () => {
	const {t} = useTranslation();

	return (
		<section className="section section--tint" id="how-it-works">
			<Container>
				<div className="section__head">
					<h2 className="section__title">{t("howItWorks.title")}</h2>
					<p className="section__subtitle">{t("howItWorks.subtitle")}</p>
				</div>
				<div className="row g-4">
					{stepKeys.map((key, index) => (
						<div key={key} className="col-12 col-sm-6 col-lg-3">
							<div className="step-card">
								<span className="step-card__number">{index + 1}</span>
								<h3 className="step-card__title">{t(`howItWorks.steps.${key}.title`)}</h3>
								<p className="step-card__text">{t(`howItWorks.steps.${key}.text`)}</p>
							</div>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
};
